<template>
  <v-row no-gutters class="number-picker-container">
    <v-col class="flex-grow-0">
      <v-btn
        class="mx-2"
        fab
        outlined
        large
        color="primary"
        :disabled="!canIncrement(-1)"
        data-qa="decrement_button"
        @click="increment(-1)"
      >
        -
      </v-btn>
    </v-col>
    <v-col>
      <div class="number-control">
        <bm-number
          :value="value"
          :min="min"
          :max="max"
          :label="label"
          :rules="rules"
          :data-qa="dataQa"
          :integral="integral"
          @update:value="setValue"
        ></bm-number>
      </div>
    </v-col>
    <v-col class="flex-grow-0">
      <v-btn
        class="mx-2"
        fab
        outlined
        large
        color="primary"
        :disabled="!canIncrement(1)"
        data-qa="increment_button"
        @click="increment(1)"
      >
        +
      </v-btn>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import BmNumber from "@/components/controls/input/BmNumber.vue";

interface DaNumberProps {
  value: number;
  min?: number;
  max?: number;
  label?: string | null;
  rules?: readonly any[];
  dataQa?: object | string;
  integral?: boolean;
}

interface DaNumberEvents {
  (event: "update:value", value: number): void;
}

const props = withDefaults(defineProps<DaNumberProps>(), {
  integral: false,
});
const emit = defineEmits<DaNumberEvents>();

const setValue = (newValue: number) => {
  emit("update:value", newValue);
};

const canIncrement = (delta: number) => {
  const newVal = (props.value || 0) + delta;
  return (
    newVal >= (props.min ?? Number.NEGATIVE_INFINITY) &&
    newVal <= (props.max ?? Number.POSITIVE_INFINITY)
  );
};

const increment = (delta: number) => {
  if (canIncrement(delta)) {
    setValue((props.value || 0) + delta);
  }
};
</script>

<style scoped lang="sass">

.number-picker-container
  max-width: 350px

.number-control
  display: inline-block
  padding: 0 6px
  width: 100%

:deep(.v-btn--outlined)
  font-family: Nunito,sans-serif
  font-size: 32px

:deep(.v-text-field input)
  text-align: center
</style>
